import React from "react";
import { useEffect, useState, createContext, useRef } from 'react';
import request from '../../../Helpers/API';
import Swal from "sweetalert2";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import SaveIcon from '@mui/icons-material/Save';

export const PolizasDuplicadasSection = ({ data, botones }) => {
    const [invoice, setInvoice] = useState([]);
    const [movimientos, setMovimientos] = useState([]);
    const [selectedInvoice, setSelectedInvoice] = useState();
    const [selectedMovimientos, setSelectedMovimientos] = useState([]);
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });


    useEffect(() => {
        setMovimientos([]);
        setSelectedMovimientos([]);
        setSelectedInvoice();
        setInvoice(data)
    }, [data]);

    const onSearchBatch = (batch, invoice) => {
        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });
            request
                .get(`ListadoInvoiceMoviemientos/ObtenerListadoMovimientosContables?batch=${batch}&invoice=${invoice}`)
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    setMovimientos(result);
                    const seleccionados = result
                        .filter(x => x.chk)
                        .map(x => x.idmovimiento);
                    setSelectedMovimientos(seleccionados);
                    return;
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    // reject(error);
                    Swal.fire("DASHBOARD FISCAL", JSON.stringify(error), "error");
                    // console.log(error)
                    return;
                });
        });
    };

    const handleClickInvoice = (batch, invoice) => {
        setSelectedInvoice(invoice);
        setSelectedMovimientos([]);
        onSearchBatch(batch, invoice);
    }

    const handleSelectMovimiento = (mov) => {
        setSelectedMovimientos(prev => {
            const exists = prev.includes(mov.idmovimiento);

            if (exists) {
                return prev.filter(id => id !== mov.idmovimiento);
            } else {
                return [...prev, mov.idmovimiento];
            }
        });
    };

    const buildDetalle = () => {
        if (!selectedInvoice) return [];

        return movimientos.map(mov => ({
            idInvoice: selectedInvoice,
            idMovimiento: mov.idmovimiento,
            chk: selectedMovimientos.includes(mov.idmovimiento) ? 1 : 0
        }));
    };

    const totalSeleccionados = movimientos
        .filter(mov => selectedMovimientos.includes(mov.idmovimiento))
        .reduce((sum, mov) => sum + (mov.importe || 0), 0);

    const importeInvoiceSeleccionado = invoice
        .find(inv => inv.idregistro === selectedInvoice)?.importe || 0;

    const diferenciaInvoiceMovimientos = selectedMovimientos.length > 0 ? Math.abs(importeInvoiceSeleccionado - totalSeleccionados).toFixed(2) : 0;

    
    const onAplicar = () => {
        console.log(diferenciaInvoiceMovimientos)
        if (diferenciaInvoiceMovimientos !== 0 && diferenciaInvoiceMovimientos !== 0.0 && diferenciaInvoiceMovimientos !== 0.00 && diferenciaInvoiceMovimientos !== "0" && diferenciaInvoiceMovimientos !== "0.0" && diferenciaInvoiceMovimientos !== "0.00") {
            Swal.fire(
                "CORRECCION DE INCIDENCIAS",
                `El importe de la factura seleccionada no coincide con el de los movimientos seleccionados`,
                "warning"
            );
            return;
        }
        const detalle = buildDetalle();
        setLoader({ ...loader, mostrar: true });
        request
            .post("ListadoInvoiceMoviemientos/GuardarRelacion", {
                detalle: JSON.stringify(detalle)
            })
            .then(() => {
                setLoader({ ...loader, mostrar: false });

                Swal.fire(
                    "Éxito",
                    "Relación guardada correctamente",
                    "success"
                );
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "Error",
                    JSON.stringify(error),
                    "error"
                );
            });
    };



    return (
        <div className="listado-fiscal-invoicemovimientos-container">
            <div className="listado-fiscal-invoicemovimientos-container-tabla scroll">
                <table>
                    <thead>
                        <tr>
                            <th colSpan={7}>
                                Facturación
                            </th>
                        </tr>
                        <tr>
                            {/* <th>
                                ID
                            </th> */}
                            <th>
                                Documento
                            </th>
                            <th>
                                <div>Fecha</div>
                            </th>
                            <th>
                                <div>Importe</div>
                            </th>
                            <th>
                                <div>Serie Fiscal</div>
                            </th>
                            <th>
                                <div>Folio Fiscal</div>
                            </th>
                            <th>
                                <div>Batch</div>
                            </th>
                            <th>
                                <div>Usuario</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {invoice.map((inv) => (
                            <tr onClick={() => handleClickInvoice(inv.batch, inv.idregistro)} className={selectedInvoice === inv.idregistro ? "selected-row" : ""}>
                                {/* <td className="ta-center">{inv.idregistro}</td> */}
                                <td className="ta-center">{inv.documento}</td>
                                <td className="ta-center">{new Date(inv.fecha).toLocaleDateString("es-MX", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric"
                                })}</td>
                                <td className="ta-right">{FormatMoney(inv.importe)}</td>
                                <td className="ta-center">{inv.serie_fiscal}</td>
                                <td className="ta-center">{inv.folio_fiscal}</td>
                                <td className="ta-center">{inv.batch}</td>
                                <td className="ta-center">{inv.usuario}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="listado-fiscal-invoicemovimientos-container-tabla scroll">
                <table>
                    <thead>
                        <tr>
                            <th colSpan={8}>
                                Movimientos Contables
                            </th>
                        </tr>
                        <tr>
                            <th>
                            </th>
                            {/* <th>
                                ID
                            </th> */}
                            <th>
                                Sucursal
                            </th>
                            <th>
                                <div>Departamento</div>
                            </th>
                            <th>
                                <div>Cuenta</div>
                            </th>
                            <th>
                                <div>Importe</div>
                            </th>
                            <th>
                                <div>Fecha</div>
                            </th>
                            <th>
                                <div>Batch</div>
                            </th>
                            <th>
                                <div>Usuario</div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {movimientos.map((mov) => {
                            const isChecked = selectedMovimientos.includes(mov.idmovimiento);
                            return (
                                <tr className={mov.bloqueado ? "block-row" : ""}>
                                    <td className="ta-center">
                                        <input
                                            type="checkbox"
                                            checked={isChecked}
                                            disabled={mov.bloqueado || !botones?.aplicar ? true : false}
                                            onChange={() => handleSelectMovimiento(mov)}
                                        />
                                    </td>
                                    {/* <td className="ta-center">{mov.idmovimiento}</td> */}
                                    <td className="ta-center">{mov.sucursal}</td>
                                    <td className="ta-center">{mov.departamento}</td>
                                    <td className="ta-center">{mov.cuenta}</td>
                                    <td className="ta-right">{FormatMoney(mov.importe)}</td>
                                    <td className="ta-center">{new Date(mov.fecha).toLocaleDateString("es-MX", {
                                        day: "2-digit",
                                        month: "2-digit",
                                        year: "numeric"
                                    })}</td>
                                    <td className="ta-center">{mov.batch}</td>
                                    <td className="ta-center">{mov.usuario}</td>
                                </tr>
                            );
                        })}

                        <tr style={{ fontWeight: "bold", background: "#f3f3f3" }}>
                            <td colSpan={4} className="ta-right">
                                Total
                            </td>
                            <td className="ta-right">
                                {FormatMoney(totalSeleccionados)}
                            </td>
                            <td className="ta-right">
                                Diferencia
                            </td>
                            <td className="ta-right">
                                {FormatMoney((diferenciaInvoiceMovimientos))}
                            </td>
                            <td>
                            </td>
                        </tr>
                    </tbody>
                </table>
                { botones?.aplicar && (
                <div className="buttons">
                    <button
                        className="listado-fiscal-invoicemovimientos-aplicar"
                        onClick={() => onAplicar()}
                    >
                        <SaveIcon /> Aplicar
                    </button>
                </div> )}
            </div>
        </div>
    );
};
